import {hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedSiteData} from "../../../tracking/algolytics_hits/tracked_utils/tracked_site";
import {CreditAlgolyticsViewType} from "../types/CreditAlgolyticsViewType";

export interface ICreditValuesAlgolytics {
    view_type: CreditAlgolyticsViewType;
    property_price: number;
    own_contribution_percent: number;
    own_contribution_amount: number;
    credit_period: number;
}

export const CreditValuesEvent = (eventPayload: ICreditValuesAlgolytics) => {
    const {site_id} = getTrackedSiteData();

    hitAlgolytics("credit_rate_calc", {
        site_id,
        ...eventPayload
    });
};
import {hitAlgolytics} from "@pg-mono/algolytics";

import {getTrackedSiteData} from "../../../tracking/algolytics_hits/tracked_utils/tracked_site";
import {CreditAlgolyticsViewType} from "../types/CreditAlgolyticsViewType";

export interface ICreditValuesAlgolytics {
    view_type: CreditAlgolyticsViewType;
    property_price: number;
    own_contribution_percent: number;
    own_contribution_amount: number;
    credit_period: number;
}

export const CreditValuesEvent = (eventPayload: ICreditValuesAlgolytics) => {
    const {site_id} = getTrackedSiteData();

    hitAlgolytics("credit_rate_calc", {
        site_id,
        ...eventPayload
    });
};
